import { render, staticRenderFns } from "./subproperty-importer-page.vue?vue&type=template&id=b7ab2074&"
import script from "./subproperty-importer-page.vue?vue&type=script&lang=js&"
export * from "./subproperty-importer-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports